import React, { useContext, useState } from 'react';

import ThemeContext from '../theme/ThemeContext';
import PanelBody from './PanelBody';

import styles from './Bootstrap-Card.module.scss';

const Panel: React.FC<{
  className?: string;
  title: string;
  doNotIncludeBody?: boolean;
  toggleable?: boolean;
  toggled?: boolean;
}> = (props) => {
  const [isToggled, setIsToggled] = useState<boolean>(props.toggled || false);

  const theme = useContext(ThemeContext);
  switch (theme.mode) {
    case 'admin':
      return (
        <div className={`panel panel-default ${props.className || ''}`}>
          <div
            className="panel-heading"
            style={{ cursor: props.toggleable ? 'pointer' : 'default' }}
            onClick={() => (props.toggleable ? setIsToggled(!isToggled) : null)}
          >
            {props.toggleable ? (
              <div className={styles.toggle}>
                <i className={`fas ${isToggled ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
              </div>
            ) : null}
            <h3 className="panel-title">{props.title}</h3>
          </div>
          {props.toggleable && isToggled ? null : (
            <>
              {false || props.doNotIncludeBody ? (
                props.children
              ) : (
                <PanelBody>{props.children}</PanelBody>
              )}
            </>
          )}
        </div>
      );
    case 'content':
    default:
      return (
        <div className={`card ${styles.comp} ${props.className || ''}`}>
          <div className="card-header">{props.title}</div>
          {false || props.doNotIncludeBody ? (
            props.children
          ) : (
            <div className="card-body">{props.children}</div>
          )}
        </div>
      );
  }
};

export default Panel;
